import Vue from 'vue'
import moment from 'moment'

// export default Vue.filter('timestamp', value => moment(value).zone(value).format('DD/MM/YYYY'))
// export default Vue.filter('timestamp', value => moment('2010-01-01T00:00:00.000Z', 'YYYY-MM-DDTHH:mm:ss'))
export default Vue.filter('timestamp', value => moment.utc(value).format('DD/MM/YYYY'))



// WEBPACK FOOTER //
// ./src/filters/date.filters/timestamp.filter.js